import {
    Component,
    EventEmitter,
    Input,
    OnChanges,
    Output,
    SimpleChanges,
    ViewChild
} from '@angular/core'
import { NgForm } from '@angular/forms'
import { Empresa } from '../../pkw-data/core/empresa.model'
import { FiltroExtrato } from '../shared/filtro-extrato'
import { PeriodoExtrato } from '../shared/periodo-extrato'
import { Agrupador } from '../../pkw-data/collect/extrato/agrupador.enum'

@Component({
    selector: 'col-filtro-extratos-form',
    templateUrl: './filtro-extratos-form.component.html'
})
export class FiltroExtratosFormComponent implements OnChanges {
    @Input() empresas: Empresa[]
    @Input() disabled: boolean

    @Output() submit: EventEmitter<FiltroExtrato>

    @ViewChild('filtroForm') filtroForm: NgForm

    model: FiltroExtrato
    periodo: PeriodoExtrato
    submitted: boolean
    periodos: PeriodoExtrato[]
    agrupador: Agrupador
    agrupadores: Agrupador[]

    constructor() {
        this.periodos = [
            PeriodoExtrato.Ontem,
            PeriodoExtrato.Ultimos7Dias,
            PeriodoExtrato.Ultimos15Dias,
            PeriodoExtrato.Ultimos30Dias,
            PeriodoExtrato.Personalizado
        ]
        this.agrupadores = [
           Agrupador.Operadora,
           Agrupador.Estabelecimento
        ]
        this.submitted = false
        this.submit = new EventEmitter<FiltroExtrato>()
        this.model = new FiltroExtrato()
    }

    get datasDesabilitadas() {
        return this.periodo !== PeriodoExtrato.Personalizado
    }

    ngOnChanges(changes: SimpleChanges) {
        if ('empresas' in changes && this.empresas) {
            this.limparFiltro()
            this.submit.emit(this.model)
        }
    }

    onNgFormSubmit($event: Event) {
        $event.stopPropagation()

        if (this.filtroForm.valid) {
            const filtro = Object.assign(new FiltroExtrato(), this.model)
            this.model.agrupador = this.agrupador.id
            this.submitted = true
            filtro.agrupador = this.agrupador.id
            this.submit.emit(filtro)
        }
    }

    limparFiltro() {
        this.model.empresa = this.empresas[0]
        this.periodo = PeriodoExtrato.Ultimos7Dias
        this.agrupador = Agrupador.Operadora
        this.verificarPeriodo()

        this.submitted = false
        this.filtroForm.resetForm({
            empresa: this.empresas[0],
            periodo: PeriodoExtrato.Ultimos7Dias,
            inicio: this.model.inicio,
            fim: this.model.fim,
            agrupador: Agrupador.Operadora
        })
    }

    verificarPeriodo() {
        const agora = new Date()
        const ontem = new Date(agora.getFullYear(), agora.getMonth(), agora.getDate() - 1)

        switch (this.periodo) {
            case PeriodoExtrato.Ontem:
                this.model.inicio = ontem
                this.model.fim = ontem
                break

            case PeriodoExtrato.Ultimos7Dias:
                this.model.inicio = new Date(
                    ontem.getFullYear(),
                    ontem.getMonth(),
                    ontem.getDate() - 7
                )
                this.model.fim = new Date(
                    ontem.getFullYear(),
                    ontem.getMonth(),
                    ontem.getDate()
                )
                break

            case PeriodoExtrato.Ultimos15Dias:
                this.model.inicio = new Date(
                    ontem.getFullYear(),
                    ontem.getMonth(),
                    ontem.getDate() - 15
                )
                this.model.fim = new Date(
                    ontem.getFullYear(),
                    ontem.getMonth(),
                    ontem.getDate()
                )
                break

            case PeriodoExtrato.Ultimos30Dias:
                this.model.inicio = new Date(
                    ontem.getFullYear(),
                    ontem.getMonth(),
                    ontem.getDate() - 30
                )
                this.model.fim = new Date(
                    ontem.getFullYear(),
                    ontem.getMonth(),
                    ontem.getDate()
                )
                break

            default:
                this.model.inicio = undefined
                this.model.fim = undefined
        }
    }
}



// WEBPACK FOOTER //
// ./src/app/extratos/filtro-extratos-form/filtro-extratos-form.component.ts